export default __webpack_public_path__ + "locales/ru/ChangePortalOwner.json?hash=351d51c81adf453a7fd8c4440ddefa43";